import type { PopupInfo, PopupInfoResponse } from '~/types/display/popup'
import { getImgBaseUrl } from '~/utils/shop-common'
import {
  type ShopApiCustomErrorResponse,
  type ShopApiErrorResponse,
  isShopApiErrorResponse,
} from '~/types/common/shop-api-response'

export function useShopMarketingPopupTransform() {
  const convertPopup = (
    data: PopupInfoResponse[] | ShopApiCustomErrorResponse | ShopApiErrorResponse,
  ): PopupInfo[] | ShopApiCustomErrorResponse | ShopApiErrorResponse => {
    if (isShopApiErrorResponse(data))
      return data

    return data.map((d) => {
      return {
        id: d.popupNo,
        name: d.popupNm,
        link: d.popupLink,
        imgSrc: getImgBaseUrl(d.popupImgPathNm),
        alt: d.imgAltConts ? d.imgAltConts : '',
        html: d.popupCont,
        prtTypCd: d.prtTypCd,
        popupContGbCd: d.popupContGbCd,
        popupDispLocGbCd: d.popupDispLocGbCd,
      } as PopupInfo
    })
  }
  return {
    convertPopup,
  }
}
